import { Theme } from '@mui/material/styles'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

interface StyleProps {
  viewType: 'compact' | 'detailed'
  expanded?: boolean
  touchDevice: boolean
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    cardColumn: {
      marginTop: theme.spacing(2),
      padding: theme.spacing(1),
    },
    sliderRoot: {
      position: 'relative',
      overflow: 'hidden',
      padding: theme.spacing(.5, 0, .75),
      '&:before': {
        content: '""',
        position: 'absolute',
        inset: 0,
        borderRadius: 32,
        background: 'linear-gradient(180deg, rgba(248, 250, 252, 0.92) 0%, rgba(255, 255, 255, 0) 100%)',
        pointerEvents: 'none',
      },
      '& .swiper': {
        overflow: 'hidden',
        paddingBottom: theme.spacing(1),
      },
      '& .swiper-wrapper': {
        alignItems: 'stretch',
      },
      '& .swiper-slide': {
        height: 'auto',
        display: 'flex',
      },
      '& .swiper-slide > section': {
        width: '100%',
        height: '100%',
      },
      '& .swiper-button-prev, & .swiper-button-next': {
        width: 42,
        height: 42,
        borderRadius: '50%',
        backgroundColor: 'rgba(255,255,255,.96)',
        color: '#1f2933',
        boxShadow: '0 10px 24px rgba(15, 23, 42, 0.12)',
        top: '42%',
        '&:after': {
          fontSize: 14,
          fontWeight: 700,
        },
        [theme.breakpoints.down('sm')]: {
          width: 34,
          height: 34,
          top: '40%',
          '&:after': {
            fontSize: 11,
          },
        },
      },
      '& .swiper-button-disabled': {
        opacity: .3,
      },
    },
    productGrid: {
      display: 'grid',
      // Im Detailed-Modus bleiben die Kacheln klein, bis sie explizit "expanded" sind
      gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
      gap: theme.spacing(1),
      '@media (max-width: 600px)': {
        gridTemplateColumns: 'repeat(2, 1fr)',
      },
      '& a': {
        color: 'inherit',
        textDecoration: 'inherit',
        '& .MuiCardContent-root': {
          paddingBottom: theme.spacing(1),
        },
      },
    },
    card: (props) => ({
      maxWidth: 180,
      margin: '0 auto',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      height: '100%',
      transition: 'transform 0.2s, all 0.2s',
      // Hover-Effekt nur, wenn kein Touch-Device:
      '&:hover': !props.touchDevice
        ? {
            transform: 'scale(1.03)',
            border: `1px solid ${theme.palette.primary.main}`,
          }
        : {},
      // Wenn die Karte im Detailed-Modus expanded ist, soll sie größer sein.
      ...(props.viewType === 'detailed' && props.expanded
        ? {
            gridColumn: 'span 2',
            gridRow: 'span 2',
            transformOrigin: 'right center',
          }
        : {}),
    }),
    cardLink: {
      textDecoration: 'inherit !important',
      color: 'inherit !important',
      '&:hover': {
        textDecoration: 'inherit !important',
        color: 'inherit !important',
      },
      '&:visited': {
        textDecoration: 'inherit !important',
        color: 'inherit !important',
      },
    },
    cardContent: {
      padding: theme.spacing(1),
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      justifyContent: 'space-between',
    },
    metaTitle: {
      fontSize: '0.85rem',
      textAlign: 'center',
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      minHeight: '2.6em',
    },
    priceContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      marginTop: theme.spacing(1),
    },
    priceLabel: {
      fontSize: '0.8rem',
      fontWeight: 'bold',
      textDecoration: 'none',
    },
    deliverytimeContainer: {
      marginTop: 'auto',
      textAlign: 'center',
      paddingTop: theme.spacing(1),
      minHeight: '30px',
      fontSize: '0.75rem',
    },
  })
)

export default useStyles
